/**
 * SuperUserGate — wraps admin routes; redirects non-superusers.
 * Extends AuthGate logic: requires login AND superuser role.
 */
import { useEffect, useState, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { apiUrl } from '../../config';

export default function SuperUserGate({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);
  const setAuth = useAuthStore((s) => s.setAuth);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!token) {
      const stored = localStorage.getItem('dukkan_token');
      if (stored) {
        fetch(apiUrl('/api/auth/me'), {
          headers: { Authorization: `Bearer ${stored}` },
        })
          .then((res) => {
            if (res.ok) return res.json();
            throw new Error('expired');
          })
          .then((u) => {
            setAuth(u, stored);
            setChecking(false);
          })
          .catch(() => {
            localStorage.removeItem('dukkan_token');
            setChecking(false);
          });
        return;
      }
    }
    setChecking(false);
  }, []);

  if (checking) {
    return (
      <div style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a', color: '#64748b' }}>
        Loading...
      </div>
    );
  }

  if (!user || !token) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'superuser') {
    return <Navigate to="/shops" replace />;
  }

  return <>{children}</>;
}
